import { eventActionBus } from '@/composables/EventActionBus'
import { websocketManager } from '@/composables/WebSocketManager'
import request from '@/plugins/admin_axios'
import { Notification } from '@/plugins/notifications'
import { GetUFsAPI } from '@/services/backend/utils'
import { getBiometriaConfigApi } from '@/services/backend/biometria'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import { reactive } from 'vue'
import { ref } from 'vue'
import { useTheme } from 'vuetify/lib/composables/theme'
import { useDisplay } from 'vuetify/lib/framework.mjs'

export const useSystemStore = defineStore('system', () => {
  const { mobile } = useDisplay()
  const theme = useTheme() // Pega o objeto de tema do Vuetify

  const drawer = ref(true)
  const drawerAffiliate = ref(true)
  const fixedRailAffiliate = ref(true)
  const uf_cidades = ref([])
  const uf = ref([])
  const cidadesByUF = ref([])
  const cidadesNomeByUF = ref([])
  const ultimaAtualizacao = ref(null)
  const isLoadingUF = ref(false)
  const isLoadingCidades = ref(false)
  const toggleLoginDialog = ref(false)
  const layout = reactive({
    uuid: null,
    logo: null,
    background_color: null,
    primary_color: null,
    logo_url: null,
    owner: null
  })
  const isLoadingGlobal = ref(false)
  const showMenuEcommerceResponsive = ref(false)
  const biometriaConfig = reactive({
    auto_consulta_compra: false,
    auto_consulta_agendamento: false,
    loaded: false,
  })

  const GetDrawer = computed(() => drawer.value)
  const IsMobile = computed(() => mobile.value)
  const layoutData = computed(() => layout)
  const MenuEcommerce = computed(() => {
    return [
      {
        icon: 'mdi-home',
        title: 'Home',
        value: 'home',
        to: { name: 'ecommerce-home' },
        submenu: [],
      },
      {
        icon: 'mdi-account',
        title: 'Menu 2',
        value: 'menu2',
        to: { name: 'ecommerce-home' },
        submenu: [],
      },
      {
        icon: 'mdi-account',
        title: 'Menu 3',
        value: 'menu3',
        to: null,
        submenu: [
          {
            icon: 'mdi-account',
            title: 'Submenu 1',
            value: 'submenu1',
            to: { name: 'ecommerce-home' },
          },
          {
            icon: 'mdi-account',
            title: 'Submenu 2',
            value: 'submenu2',
            to: { name: 'ecommerce-home' },
          },
        ],
      },
    ]
  })

  const ToggleDrawer = () => {
    drawer.value = !drawer.value
  }
  const ToggleRailAffiliate = () => {
    fixedRailAffiliate.value = !fixedRailAffiliate.value
  }
  const ToggleDrawerAffiliate = () => {
    drawerAffiliate.value = !drawerAffiliate.value
  }

  async function GetUFs(force = false) {
    const now = Date.now()
    const timeout = 30 * 60 * 1000

    if (force || !ultimaAtualizacao.value || now - ultimaAtualizacao.value > timeout) {
      isLoadingUF.value = true
      try {
        const response = await GetUFsAPI()
        if (response.status == 'success') {
          uf_cidades.value = response.data

          uf.value = Object.values(response.data).map(estado => ({
            label: estado.estado,
            value: estado.uf
          }));

          ultimaAtualizacao.value = now
        }
      } catch (error) {
        Notification.error('Nao foi possivel buscar os estados: ' + error.response.data.message)
      } finally {
        isLoadingUF.value = false
      }
    }

  }

  async function GetCidadesByUF(uf = false) {

    isLoadingCidades.value = true
    if (uf) {

      if (uf_cidades.value[uf]) {
        cidadesByUF.value = uf_cidades.value[uf].municipios
        cidadesNomeByUF.value = cidadesByUF.value.map(cidade => cidade.nome)
      }

    } else {
      cidadesByUF.value = []
    }

    setTimeout(() => {
      isLoadingCidades.value = false
    }, 1000)
  }
  const FetchLayoutSettings = async (isLoadApp = false, applyTheme = true) => {
    if (isLoadingGlobal.value) return

    try {
      isLoadingGlobal.value = true
      const response = await request.get('owner/layout/get/');
      if (response.status === 200) {
        layout.uuid = response.data.data.uuid
        layout.logo = response.data.data.logo
        layout.background_color = response.data.data.background_color
        layout.primary_color = response.data.data.primary_color
        layout.logo_url = response.data.data.logo_url
        layout.owner = response.data.data.owner
        if (applyTheme) {
          SetLayoutSettings()
        }
      }
    } catch (error) {
      console.log(error);
      if (error.status != 404) {
        if (isLoadApp) {
          throw new Error(error.response.data.message)
        } else {
          Notification.error(error.response.data.message)
        }
      }
    } finally {
      isLoadingGlobal.value = false
    }
  }

  const SetLayoutSettings = () => {
    const currentThemeName = theme.global.name.value
    theme.themes.value[currentThemeName].colors.primary = layout.primary_color
  }

  const OnWebsocketNotifications = () => {

    websocketManager.connect('owner_notifications', 'ws/notifications/')

    const ws_actions = {
      update_nfse_list: () => {
        eventActionBus.emit('update_nfse_list')
      }
    }

    eventActionBus.on('owner_notifications', (actionName, payload) => {
      console.log(`[SystemStore] Evento recebido do bus: ${actionName}`);
      if (ws_actions[actionName]) {
        ws_actions[actionName](payload);
      }
      return true
    })
  }

  const OffWebsocketNotifications = () => {
    websocketManager.disconnect('owner_notifications')
    eventActionBus.clear('owner_notifications')
  }

  async function fetchBiometriaConfig(force = false) {
    if (biometriaConfig.loaded && !force) return

    try {
      const response = await getBiometriaConfigApi()
      if (response.status === 'success') {
        biometriaConfig.auto_consulta_compra = !!response.data.auto_consulta_compra
        biometriaConfig.auto_consulta_agendamento = !!response.data.auto_consulta_agendamento
      }
    } catch (error) {
      console.error('Erro ao buscar configuração de biometria:', error)
    } finally {
      biometriaConfig.loaded = true
    }
  }

  return {
    toggleLoginDialog,
    drawer,
    fixedRailAffiliate,
    drawerAffiliate,
    uf,
    // Mapa completo `{UF: {uf, estado, municipios}}` — só leitura fora da store (formulário de
    // prospecto monta a lista da UF sem mexer em `cidadesNomeByUF`, usado pelo atendimento).
    uf_cidades,
    cidadesByUF,
    cidadesNomeByUF,
    isLoadingUF,
    isLoadingCidades,
    ultimaAtualizacao,
    GetDrawer,
    IsMobile,
    layoutData,
    isLoadingGlobal,
    showMenuEcommerceResponsive,
    biometriaConfig,
    MenuEcommerce,
    ToggleDrawer,
    ToggleRailAffiliate,
    ToggleDrawerAffiliate,
    GetUFs,
    GetCidadesByUF,
    FetchLayoutSettings,
    OnWebsocketNotifications,
    OffWebsocketNotifications,
    fetchBiometriaConfig,
  }
})
